import type { AnyRequestName } from "@/base/send-request"

import { getFetchStatusByName } from "@/redux/requests.reducer"
import { useRootDispatch } from "@/redux/useRootDispatch"
import { useRootSelector } from "@/redux/useRootSelector"

import { useErrorHandler, type ErrorHandlerOptions } from "./useErrorHandler"
import { useToasts } from "./useToasts"

export function useRequestHelpers(
  requestName?: AnyRequestName,
  errorHandlerOptions?: ErrorHandlerOptions,
) {
  const fetchStatus = useRootSelector((state) => {
    if (requestName) {
      return getFetchStatusByName(state, requestName)
    }
    return undefined
  })
  return {
    dispatch: useRootDispatch(),
    fetchStatus,
    // Todo: does this need to be a hook?
    handleError: useErrorHandler(errorHandlerOptions),
    isLoading: fetchStatus === "pending",
    toasts: useToasts(),
  }
}
